<template>
    <lq-el-form
        :rules="rules"
        name="reset_password"
        @submited-success="submitted"
        @submited-error="submittedError"
        :static-data="fixedData"
        action="/reset-password"
    >
        <el-card shadow="always">
            <lq-el-input id="token" :disabled="(getToken()? true: false)" placeholder="OTP/Token" />
            <lq-el-input id="password" type="password" placeholder="Password" />
            <lq-el-input id="password_confirmation" type="password" placeholder="Confirm Password" />
            <lq-el-submit label="Submit" />
        </el-card>
    </lq-el-form>
</template>
<script>
export default {
    name: 'login-form',
    props: {
        fixedData: Object
    },
    data: function() {
        return {
            rules: {
                password: {
                    // email: true,
                    presence: {
                        allowEmpty: false,
                        message: 'Required!'
                    }
                },
                token: {
                    // email: true,
                    presence: {
                        allowEmpty: false,
                        message: 'Required!'
                    }
                },
                password_confirmation: {
                    // email: true,
                    presence: {
                        allowEmpty: false,
                        message: 'Required!'
                    }
                }
            }
        };
    },
    created: function() {
        const token = this.getToken();
        if (token) {
            this.$lqForm.setElementVal('reset_password', 'token', token);
        }
    },
    methods: {
        getToken: function() {
            return this.$helper.getProp(this.$route, 'query.token', null);
        },
        submittedError: function(error) {
            if (error.response && error.response.data) {
                if (
                    error.response.data.error_code ===
                    'token_not_exist_or_may_be_expire'
                ) {
                    this.$message.error(
                        'Token has been expired. Please try again.'
                    );
                    this.$router.push('/forget-password');
                }
            }
        },
        submitted: function(resposne) {
            this.$message({
                message:
                    'Pasword has been changed successfully. Please try to login.',
                type: 'success'
            });
            this.$router.push('/');
        }
    }
};
</script>